module.exports = __webpack_public_path__ + "assets/img/driver-btn-a623b461.png";